/* Bracelet Chemin de Vie — numérologie, rendu du bracelet, ajout au panier.
   Les données viennent du bloc JSON #cdv-data écrit par la section.

   Robustesse : tous les accès au DOM passent par des helpers qui ignorent
   un élément absent, et le rendu est protégé. Si le fichier de section et
   ce script se retrouvent désynchronisés (l'import Shopify peut n'en
   reprendre qu'un des deux), l'écran continue d'avancer au lieu de rester
   figé sur le calcul. */
(function () {
  var root = document.getElementById('cdv');
  var dataEl = document.getElementById('cdv-data');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('Chemin de vie : données illisibles', e); return; }

  var SET = DATA.settings || {};
  var PATHS = {};
  (DATA.paths || []).forEach(function (p) { PATHS[String(p.n)] = p; });

  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
              'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  var RING_COUNT = 24;
  var RING_RADIUS = 124;

  var state = { firstname: '', cycles: [], life: null, stones: [], bead: '', len: '' };

  // ------------------------------------------------------------- helpers DOM
  function $(sel) { return root.querySelector(sel); }
  function setText(sel, txt) { var el = $(sel); if (el) el.textContent = txt; }
  function setHTML(sel, html) { var el = $(sel); if (el) el.innerHTML = html; }

  function screen(name) {
    var found = false;
    root.querySelectorAll('[data-screen]').forEach(function (s) {
      var on = s.dataset.screen === name;
      if (on) found = true;
      s.classList.toggle('is-on', on);
    });
    if (!found) return;
    var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function money(c) {
    return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /** Réduction numérologique. Les nombres maîtres ne sont conservés
      que pour le chemin de vie, pas pour les cycles. */
  function reduce(n, keepMasters) {
    while (n > 9) {
      if (keepMasters && (n === 11 || n === 22 || n === 33)) return n;
      n = String(n).split('').reduce(function (a, d) { return a + Number(d); }, 0);
    }
    return n;
  }
  function stoneImg(name) { var s = DATA.stones[name]; return s && s.img ? s.img : ''; }
  function supPrice(name) { var s = DATA.supplements[name]; return s ? s.price : 0; }
  function pathOf(n) {
    return PATHS[String(n)] || { n: n, title: '', claim: '', story: [], stone: '', why: '' };
  }

  /** Anneau de perles : les pierres fournies sont répétées tout autour. */
  function ring(stones, centerHTML) {
    var html = '';
    for (var i = 0; i < RING_COUNT; i++) {
      var name = stones[i % stones.length];
      var a = (i / RING_COUNT) * Math.PI * 2 - Math.PI / 2;
      html += '<span class="cdv__bead" style="transform:translate(' +
        (Math.cos(a) * RING_RADIUS).toFixed(1) + 'px,' + (Math.sin(a) * RING_RADIUS).toFixed(1) +
        'px);background-image:url(' + esc(stoneImg(name)) + ')"></span>';
    }
    return html + (centerHTML || '');
  }

  // ------------------------------------------------------------- initialisation
  (function fill() {
    var dd = $('#cdv-dd'), mm = $('#cdv-mm'), yy = $('#cdv-yy'),
        bead = $('#cdv-bead'), len = $('#cdv-len');
    if (!dd || !mm || !yy) return;

    var h = '<option value="">Jour</option>';
    for (var d = 1; d <= 31; d++) h += '<option>' + d + '</option>';
    dd.innerHTML = h;

    h = '<option value="">Mois</option>';
    MOIS.forEach(function (m, i) { h += '<option value="' + (i + 1) + '">' + m + '</option>'; });
    mm.innerHTML = h;

    var thisYear = new Date().getFullYear();
    h = '<option value="">Année</option>';
    for (var y = thisYear - 10; y >= 1930; y--) h += '<option>' + y + '</option>';
    yy.innerHTML = h;

    var beads = [], lens = [];
    (DATA.variants || []).forEach(function (v) {
      if (beads.indexOf(v.bead) === -1) beads.push(v.bead);
      if (lens.indexOf(v.len) === -1) lens.push(v.len);
    });
    if (bead) {
      bead.innerHTML = beads.map(function (b) {
        return '<option value="' + esc(b) + '"' + (b === '8mm' ? ' selected' : '') + '>' +
          esc(b.replace('mm', ' mm')) + '</option>';
      }).join('');
    }
    if (len) {
      lens.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      len.innerHTML = lens.map(function (l) {
        return '<option value="' + esc(l) + '"' + (parseInt(l, 10) === 17 ? ' selected' : '') + '>' +
          esc(l.replace('cm', ' cm')) + '</option>';
      }).join('');
    }
  })();

  // Bracelet de démonstration sur la page d'entrée
  (function demo() {
    var el = $('[data-hero-strand]');
    if (!el) return;
    var stones = (SET.heroStones || []).map(function (s) { return String(s).trim(); })
      .filter(function (s) { return s && DATA.stones[s]; });
    if (!stones.length) stones = Object.keys(DATA.stones).slice(0, 4);
    if (!stones.length) return;
    el.innerHTML = ring(stones,
      '<span class="cdv__core"><span class="cdv__core-kicker">Votre bracelet</span>' +
      '<span class="cdv__core-mid">4 pierres</span>' +
      '<span class="cdv__core-small">une par nombre</span></span>');
  })();

  function variantFor(bead, len) {
    return (DATA.variants || []).filter(function (v) { return v.bead === bead && v.len === len; })[0] || null;
  }

  // ------------------------------------------------------------- calcul
  var goBtn = $('[data-go]');
  if (goBtn) goBtn.addEventListener('click', function () {
    var dEl = $('#cdv-dd'), mEl = $('#cdv-mm'), yEl = $('#cdv-yy');
    var d = parseInt(dEl && dEl.value, 10), m = parseInt(mEl && mEl.value, 10), y = parseInt(yEl && yEl.value, 10);
    var err = $('[data-err]');
    if (!d || !m || !y) { if (err) err.classList.add('is-on'); return; }
    if (err) err.classList.remove('is-on');

    var fnEl = $('#cdv-fn'), bEl = $('#cdv-bead'), lEl = $('#cdv-len');
    state.firstname = ((fnEl && fnEl.value) || '').trim();
    state.bead = (bEl && bEl.value) || '8mm';
    state.len = (lEl && lEl.value) || '17cm';
    state.cycles = [reduce(m, false), reduce(d, false), reduce(y, false)];
    state.life = reduce(state.cycles[0] + state.cycles[1] + state.cycles[2], true);
    state.stones = state.cycles.map(function (n) { return pathOf(n).stone; });
    state.stones.push(pathOf(state.life).stone);

    screen('calc');
    var msgs = ['Nous lisons votre date…', 'Nous calculons vos trois cycles…', 'Nous cherchons vos pierres…'];
    var i = 0;
    var tick = setInterval(function () {
      setText('[data-tick]', Math.floor(Math.random() * 9) + 1);
      if (i < msgs.length) setText('[data-calcmsg]', msgs[i++]);
    }, 640);
    setTimeout(function () {
      clearInterval(tick);
      try { render(); }
      catch (e) { console.error('Chemin de vie : rendu impossible', e); }
      screen('result');
    }, 2200);
  });

  var againBtn = $('[data-restart]');
  if (againBtn) againBtn.addEventListener('click', function () { screen('form'); });

  // ------------------------------------------------------------- rendu
  function render() {
    var L = pathOf(state.life);
    var labels = (SET.cycleLabels || []).map(function (l) {
      var p = String(l).split('::');
      return { t: (p[0] || '').trim(), s: (p[1] || '').trim(), d: (p[2] || '').trim() };
    });

    setText('[data-hello]', (state.firstname ? state.firstname + ' · ' : '') + 'Votre chemin de vie');
    setHTML('[data-master]', state.life > 9 ? '<span class="cdv__master">Nombre maître</span>' : '');
    setText('[data-num]', state.life);
    setText('[data-arch]', L.title);
    setText('[data-claim]', L.claim);
    setHTML('[data-story]', (L.story || []).map(function (p) {
      return '<p class="cdv__story">' + esc(p) + '</p>';
    }).join(''));

    setHTML('[data-strand]', ring(state.stones,
      '<span class="cdv__core"><span class="cdv__core-kicker">Chemin de vie</span>' +
      '<span class="cdv__core-big">' + state.life + '</span>' +
      '<span class="cdv__core-small">' + esc(L.title) + '</span></span>'));
    setText('[data-cap]', state.stones.join(' · ') + ' — perles ' + state.bead + ', montage ' + state.len);

    setHTML('[data-stones]', state.stones.map(function (name, i) {
      var hero = i === 3;
      var S = hero ? L : pathOf(state.cycles[i]);
      var lab = labels[i] || { t: 'Cycle ' + (i + 1), s: '', d: '' };
      var role = hero ? 'Votre pierre maîtresse' : lab.t + ' · ' + lab.s + ' · nombre ' + state.cycles[i];
      var intro = hero ? '' : (lab.d ? lab.d.charAt(0).toUpperCase() + lab.d.slice(1) + '. ' : '');
      var swap = SET.allowSwap
        ? '<button type="button" class="cdv__swap" data-slot="' + i + '">Changer cette pierre</button>' : '';
      return '<div class="cdv__stone' + (hero ? ' cdv__stone--hero' : '') + '">' +
        '<img src="' + esc(stoneImg(name)) + '" alt="' + esc(name) + '" loading="lazy">' +
        '<div><p class="cdv__stone-role">' + esc(role) + '</p>' +
        '<p class="cdv__stone-name">' + esc(name) + '</p>' +
        '<p class="cdv__stone-why">' + esc(intro) + esc(S.why) + '</p>' + swap + '</div></div>';
    }).join(''));

    var variant = variantFor(state.bead, state.len);
    var base = variant ? variant.price : 0;
    var sup = state.stones.reduce(function (a, n) { return a + supPrice(n); }, 0);
    var total = base + sup;

    setHTML('[data-lines]',
      '<div class="cdv__line"><span>Bracelet ' + esc(state.bead.replace('mm', ' mm')) + ' · ' +
        esc(state.len.replace('cm', ' cm')) + '</span><b>' + money(base) + '</b></div>' +
      state.stones.map(function (n) {
        return '<div class="cdv__line"><span>' + esc(n) + '</span><b>+ ' + money(supPrice(n)) + '</b></div>';
      }).join('') +
      '<div class="cdv__line cdv__line--tot"><span>Total</span><b>' + money(total) + '</b></div>');

    setText('[data-total]', money(total));
    var add = $('[data-add]');
    if (add) add.disabled = !variant;
  }

  // ------------------------------------------------------------- échange
  var modal = $('[data-modal]');
  var swapSlot = null;

  root.addEventListener('click', function (e) {
    var b = e.target.closest('.cdv__swap');
    if (!b || !SET.allowSwap || !modal || !modal.showModal) return;
    swapSlot = parseInt(b.dataset.slot, 10);
    setHTML('[data-grid]', Object.keys(DATA.stones).sort(function (a, b2) {
      return a.localeCompare(b2, 'fr');
    }).map(function (name) {
      if (!DATA.supplements[name]) return '';
      return '<button type="button" class="cdv__pick" data-stone="' + esc(name) + '">' +
        '<img src="' + esc(stoneImg(name)) + '" alt="" loading="lazy">' +
        '<span class="cdv__pick-n">' + esc(name) + '</span>' +
        '<span class="cdv__pick-p">+ ' + money(supPrice(name)) + '</span></button>';
    }).join(''));
    modal.showModal();
  });

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-modal-close]')) { modal.close(); return; }
      var pick = e.target.closest('.cdv__pick');
      if (!pick || swapSlot === null) return;
      state.stones[swapSlot] = pick.dataset.stone;
      modal.close();
      try { render(); } catch (err) { console.error(err); }
    });
  }

  // ------------------------------------------------------------- panier
  var addBtn = $('[data-add]');
  if (addBtn) addBtn.addEventListener('click', function () {
    var variant = variantFor(state.bead, state.len);
    if (!variant) return;

    var group = Date.now().toString();
    var props = { '_bracelet_group': group, 'Chemin de vie': String(state.life) };
    state.stones.forEach(function (n, i) { props['Perle ' + (i + 1)] = n; });
    props['Taille des perles'] = state.bead;
    props['Taille du bracelet'] = state.len;

    var items = [{ id: variant.id, quantity: 1, properties: props }];
    state.stones.forEach(function (n, i) {
      var sup = DATA.supplements[n];
      if (!sup) return;
      items.push({
        id: sup.id, quantity: 1,
        properties: { '_bracelet_group': group, '_slot': String(i + 1), '_stone': n }
      });
    });

    // On demande le re-rendu de la section panier dans la réponse
    var body = { items: items };
    var comp = document.querySelector('cart-items-component');
    if (comp && comp.dataset && comp.dataset.sectionId) {
      body.sections = comp.dataset.sectionId;
      body.sections_url = window.location.pathname;
    }

    // Événement natif Horizon envoyé AVANT le fetch. C'est l'action « add »
    // qui déclenche l'ouverture automatique du tiroir ; « update » ne l'ouvre pas.
    var resolveLines;
    var pending = new Promise(function (res) { resolveLines = res; });
    var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'add';
    ev.context = 'product';
    ev.promise = pending;
    document.dispatchEvent(ev);

    addBtn.classList.add('is-loading');
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('ajout refuse');
        return r.json();
      })
      .then(function (data) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { data: data, cart: cart }; })
          .catch(function () { return { data: data, cart: null }; });
      })
      .then(function (res) {
        var sections = res.data && res.data.sections ? res.data.sections : undefined;
        // Compteur visible : les lignes de supplement sont masquees dans le tiroir
        var count;
        if (res.cart) {
          count = res.cart.items.reduce(function (acc, it) {
            return acc + (it.handle === 'supplement-pierre-bracelet' ? 0 : it.quantity);
          }, 0);
        }
        resolveLines({ detail: { sections: sections, itemCount: count } });

        // Scripts historiques : reconciliation cadeaux et barre de progression
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true, detail: { data: { sourceId: 'chemin-de-vie' } }
        }));

        // Ouverture de secours si l'ouverture automatique est desactivee
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
          try { drawer.open(); } catch (e) {}
        }

        // Filet : si le tiroir est reste vide, on force un re-rendu
        setTimeout(function () {
          var ligne = document.querySelector('cart-items-component tbody .cart-items__table-row[data-key]');
          if (!ligne) {
            var force = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
            force.action = 'update';
            force.promise = Promise.resolve({ detail: {} });
            document.dispatchEvent(force);
          }
        }, 900);
      })
      .catch(function (err) {
        console.error('Chemin de vie : ajout au panier impossible', err);
        resolveLines({ detail: { didError: true } });
        alert("Une erreur est survenue lors de l'ajout au panier. Veuillez reessayer.");
      })
      .then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
      });
  });

})();
